import { Injectable } from '@angular/core';
import { GatewayAPIService } from '../../core/gateway-api.service';
import { Person } from '../person/person';
import { Account } from './account';
import { User } from '../users/user';
import { StorageService } from '../../core/storage/storageService';
import { Page } from '../../components/ui/filterable-table/tableViewAbstractComponent';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  options = { authenticate: true, setRoot: true };

  constructor(
    private api: GatewayAPIService,
    private storage: StorageService,
  ) {}

  public createAccount(
    accountName: string,
    owner: Partial<Person>,
    user: Partial<User>,
  ): Promise<string> {
    let data = {
      businessName: accountName,
      owner: owner,
      user: user,
    };

    return this.post(data);
  }

  public getPaged(query: string, data: any): Promise<Page<Account>> {
    data.q = query;

    return this.api
      .apiCallSane(
        '/accounts',
        'GET',
        this.api.getDefaultHeaders(),
        data,
        null,
        this.options,
      )
      .then((response: Partial<Page<Account>>) => new Page<Account>(response));
  }

  public getAccount(id: string): Promise<Account> {
    return this.get({ businessId: id });
  }

  async patchAccountInfo(data: Partial<Account>): Promise<any> {
    let d = {
      businessId: data.id,
      contact: data.owner,
      accountName: data.accountName,
    };
    return await this.patch(d, 'info');
  }

  async patchBillingInfo(data: Partial<Account>): Promise<any> {
    return await this.patch(data, 'billing-info');
  }

  private get(data: any): Promise<Account> {
    return this.api.apiCallSane(
      '/account',
      'GET',
      this.api.getDefaultHeaders(),
      data,
      null,
      this.options,
    );
  }

  private post(data: any): Promise<string> {
    return this.api.apiCallSane(
      '/account',
      'POST',
      this.api.getDefaultHeaders(),
      null,
      data,
      this.options,
    );
  }

  // TODO: remove [which], update endpoint merchant/(PATCH) to look for changed fields in request
  private patch(data: any, which: string): Promise<any> {
    let endpointLocation = '';

    if (which != '') {
      endpointLocation = '/' + which;
    }
    /*
        let usr = this.storage.getCurrentUser();

        if (usr) {
            data.userId = usr.id;
        }
*/
    return this.api.apiCallSane(
      '/account' + endpointLocation,
      'PATCH',
      this.api.getDefaultHeaders(),
      null,
      data,
      this.options,
    );
  }
}
